import React, { useRef } from "react";
import styled, { keyframes } from "styled-components";

import card1 from "../../assets/images/brow1.jpg";
import card2 from "../../assets/images/brow2.jpeg";
import card3 from "../../assets/images/brow3.jpeg";
import card4 from "../../assets/images/brow4.jpg";
import card5 from "../../assets/images/brow5.jpg";
import card6 from "../../assets/images/brow6.jpg";
import card7 from "../../assets/images/brow7.jpg";
import card8 from "../../assets/images/brow8.jpg";
import card9 from "../../assets/images/brow9.jpg";
import card10 from "../../assets/images/brow10.jpg";

const Section = styled.section`
  min-height: 50vh;
  width: 100vw;
  background-color: ${(props) => props.theme.text};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  & > *:first-child {
    animation-duration: 30s;

    @media (max-width: 30em) {
      animation-duration: 30s;
    }
  }
  & > *:last-child {
    animation-duration: 30s;
    @media (max-width: 30em) {
      animation-duration: 30s;
    }
  }
`;
const move = keyframes`
0%{ transform: translateX(100%)   };
100%{ transform: translateX(-100%)   }

`;

const Row = styled.div`
  /* background-color: lightblue; */
  white-space: nowrap;
  box-sizing: content-box;
  margin: 5rem 3rem;
  display: flex;

  animation: ${move} linear infinite ${(props) => props.direction};
`;
const ImgContainer = styled.div`
  width: 15rem;
  margin: 0 1rem;
  height: 15rem;
  border-radius: 20px;
  cursor: pointer;

  @media (max-width: 48em) {
    width: 12rem;
  }
  @media (max-width: 30em) {
    width: 10rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const Details = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.8rem 1rem;
  background-color: #ffcee6;
  border: 2px solid #f5347f;

  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  span {
    font-size: ${(props) => props.theme.fontsm};
    color: #f5347f;
    font-weight: 600;
    line-height: 1.5rem;

    @media (max-width: 30em) {
      font-size: ${(props) => props.theme.fontxs};
    }
  }

  h1 {
    font-size: ${(props) => props.theme.fontmd};
    color: ${(props) => props.theme.body};
    font-weight: 600;

    @media (max-width: 30em) {
      font-size: ${(props) => props.theme.fontxs};
    }
  }
`;

const Price = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 1rem;
    height: auto;
  }
`;

const NftItem = ({ img, number = 0, price = 0, passRef }) => {
  let play = (e) => {
    passRef.current.style.animationPlayState = "running";
  };
  let pause = (e) => {
    passRef.current.style.animationPlayState = "paused";
  };

  return (
    <ImgContainer onMouseOver={(e) => pause(e)} onMouseOut={(e) => play(e)}>
      <img width={400} height={400} src={img} alt="The Weirdos" />
      <Details>
        <div>
          <span>Nelsonlashandbrows</span> <br />
          {/* <h1>#{number}</h1> */}
        </div>

        <div>
          {/* <span>Price</span> */}
          <Price>
            {/* <img width={200} height={200}  src={ETH} alt="ETH" /> */}
            {/* <h1>{Number(price).toFixed(1)}</h1> */}
          </Price>
        </div>
      </Details>
    </ImgContainer>
  );
};

const Showcase = () => {
  const Row1Ref = useRef(null);
  const Row2Ref = useRef(null);

  return (
    <Section
      id="photos"
      style={{
        background: "radial-gradient(circle at bottom left, #F3ADB8, #F9D3D8)",
      }}
    >
      <Row direction="none" ref={Row1Ref}>
        <NftItem img={card1} number={852} price={1} passRef={Row1Ref} />
        {/* <NftItem img={card2} number={123} price={1.2} passRef={Row1Ref} /> */}
        <NftItem img={card3} number={456} price={2.5} passRef={Row1Ref} />
        <NftItem img={card4} number={666} price={3.5} passRef={Row1Ref} />
        <NftItem img={card5} number={452} price={4.7} passRef={Row1Ref} />
        <NftItem img={card6} number={888} price={1.2} passRef={Row2Ref} />
        <NftItem img={card7} number={211} price={3.2} passRef={Row2Ref} />
        <NftItem img={card8} number={455} price={1.8} passRef={Row2Ref} />
        <NftItem img={card9} number={456} price={5.1} passRef={Row2Ref} />
        <NftItem img={card10} number={865} price={3.7} passRef={Row2Ref} />
      </Row>
    </Section>
  );
};

export default Showcase;
